// extracted by mini-css-extract-plugin
module.exports = {"wave_box":"ParkRoad_wave_box__2NV8i","wave_box_title":"ParkRoad_wave_box_title__1b9HZ","wave_item":"ParkRoad_wave_item__2HnP4","wave_item_label":"ParkRoad_wave_item_label__2Sq_H"};